import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './prompts.loaders';
import { promptsKeys } from './prompts.queries';

export const useCreatePrompt = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createPrompt, {
    onSuccess: () => {
      return queryClient.invalidateQueries(promptsKeys.lists);
    },
  });
};

export const useUpdatePrompt = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updatePrompt, {
    onSuccess: () => {
      return queryClient.invalidateQueries(promptsKeys.all);
    },
  });
};

export const useDeletePrompt = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deletePrompt, {
    onSuccess: () => {
      return queryClient.invalidateQueries(promptsKeys.lists);
    },
  });
};
